<div class="modal-header">
  <h3 class="modal-title">{{$apropriacaoModal.aplicacao.tipo_operacao}}</h3>
</div>
<div class="modal-body">
  <dl class="dl-horizontal">
    <dt>Propriedade:</dt>
    <dd>{{$apropriacaoModal.aplicacao.propriedade.descricao}}</dd>

    <dt ng-if="!$apropriacaoModal.isTratamentoSemente">Talhão:</dt>
    <dd ng-if="!$apropriacaoModal.isTratamentoSemente">{{$apropriacaoModal.aplicacao.gleba.descricao}}</dd>

    <dt>Produtos:</dt>
    <dd>
      <span ng-repeat="produto in $apropriacaoModal.aplicacao.produtos">{{produto.descricao}}, </span>
    </dd>
  </dl>

  <div class="row">
    <p class="text-cinza text-center" ng-show="$apropriacaoModal.loading">
      <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i> Aguarde...
    </p>
    <div class="col-xs-6 text-right" ng-hide="$apropriacaoModal.loading || $apropriacaoModal.associar">
      <button ng-disabled="$apropriacaoModal.errorLoadAplicacoes" class="btn btn-primary btn-primary" type="button" ng-click="$apropriacaoModal.initAssociar()">Verificar aplicações existentes</button>
      <p class="text-danger text-center">{{$apropriacaoModal.errorLoadAplicacoes}}</p>
    </div>
    <div class="col-xs-6 text-left" ng-hide="$apropriacaoModal.loading || $apropriacaoModal.associar">
      <button class="btn btn-primary btn-danger" type="button" ng-click="$apropriacaoModal.remove()">Excluir Aplicação pendente</button>
    </div>
  </div>

  <div class="row" ng-show="$apropriacaoModal.associar">
    <div class="col-xs-12 text-center" ng-show="$apropriacaoModal.loadingAplicacoes">
      <i class="fa fa-spinner fa-pulse fa-fw text-cinza"></i>
    </div>

    <div class="col-xs-12 text-center" ng-show="!$apropriacaoModal.loadingAplicacoes && !$apropriacaoModal.aplicacoes.length">
      <small class="text-danger">Nenhuma aplicação encontrada!</small>
    </div>

    <div class="col-xs-8 form-group" ng-hide="$apropriacaoModal.loadingAplicacoes || !$apropriacaoModal.aplicacoes.length">
      <label for="select-aplicacao">Selecione a aplicação</label>
      <select ng-disabled="$apropriacaoModal.loading" id="select-aplicacao" ng-model="$apropriacaoModal.aplicacaoAssociada" ng-options="aplicacao as $apropriacaoModal.descriptionAplicacao(aplicacao) for aplicacao in $apropriacaoModal.aplicacoes track by apicacao.id" class="form-control"></select>
    </div>

    <div class="col-xs-4 form-group text-left" ng-hide="$apropriacaoModal.loadingAplicacoes || !$apropriacaoModal.aplicacoes.length">
      <label>&nbsp;</label><br>
      <button ng-disabled="$apropriacaoModal.loading" class="btn btn-primary" ng-disabled="!$apropriacaoModal.aplicacaoAssociada" ng-click="$apropriacaoModal.aprove()">Associar!</button>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-primary" type="button" ng-click="$apropriacaoModal.close()">Cancelar</button>
</div>
